import React, { type FunctionComponent } from 'react';
import BreakPoints from '~/components/BreakPoints';
import Icon from '~/components/Icon';
import Text from '~/components/Text';

const PhoneLink: FunctionComponent = function () {
  const content = (
    <div className="flex flex-row items-center justify-center mr-4 text-neutral-700 gap-x-2">
      <Icon icon="phone" size={18} /> <Text text="03308187500" />
    </div>
  );

  return (
    <BreakPoints
      desktop={content}
      mobile={<a href="tel:443308187500">{content}</a>}
    />
  );
};

export default PhoneLink;
